/**
 * `SonsDuJeu` — l'appelant des trois SFX « d'action » de la liste fermée (SPEC-UI §7.6) :
 * `cash_in` / `cash_out` (mouvements de Clicks) et `sleep_transition` (Dormir).
 *
 * Composant sans rendu, monté à la racine comme `AmbianceSM` ⟦A-76⟧ — et pour la même raison :
 * un mouvement de Clicks est un fait du TOUR, pas d'un écran. Le lit de la chambre, le bouton
 * « Dormir » de la barre et la télécommande de dev déclenchent tous la même action `sleep` ;
 * brancher le son sur l'action plutôt que sur trois boutons, c'est ne pas en oublier un.
 *
 * Il lit `runStore.derniereAction` — le type de l'action qui vient de réussir et le solde
 * avant/après, posés par `act()` — et demande à `sonsDuTour` (pur, testé) quoi jouer. Il
 * n'écrit rien, nulle part : le son ne décide jamais ⟦A-22⟧.
 */

import { useEffect } from "react";

import { useSfx } from "../components/SoundProvider";
import { useRunStore } from "../stores/runStore";

import { sonsDuTour } from "./sons";

export function SonsDuJeu() {
  const sfx = useSfx();
  const derniere = useRunStore((s) => s.derniereAction);

  useEffect(() => {
    if (!derniere) return;
    for (const id of sonsDuTour(derniere.type, derniere.argent_avant, derniere.argent_apres)) {
      sfx(id);
    }
    // `derniere.id` : deux actions identiques d'affilée (deux achats) doivent sonner deux fois.
  }, [derniere, sfx]);

  return null;
}
